'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _superagent = require('./superagent');

Object.defineProperty(exports, 'superagent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_superagent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }